import React from 'react';
import type { BookEdition } from './types';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface EditionModalProps {
  darkMode: boolean;
  onAddEdition: (format: BookEdition['format']) => void;
  onClose: () => void;
}
export const EditionModal: React.FC<EditionModalProps> = ({
  darkMode,
  onAddEdition,
  onClose
}) => {
  const dk = useDarkClasses();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-21057" data-mp="2a6futl91bsc7">
      <div className={`w-full max-w-md p-6 rounded-xl shadow-xl ${dk.card}`} data-id="element-21058" data-mp="2f5sfbzcfonbm">
        <h3 className={`text-xl font-bold mb-4 ${dk.textHeading}`} data-id="element-21059" data-mp="21dudm9l1xtph">
          Add New Edition
        </h3>
        <div className="grid grid-cols-2 gap-4" data-id="element-21060" data-mp="25f7juks23ywx">
          {(['paperback', 'hardcover', 'special', 'eBook'] as const).map(format => <button key={format} onClick={() => {
          onAddEdition(format);
          onClose();
        }} className={`p-4 text-left border rounded-lg transition-colors ${dk.surfaceMuted} ${dk.border} hover:${dk.surfaceMuted}`} data-id="element-21061" data-mp="2t3h2jdtz46ju">
                <div className={`font-medium capitalize ${dk.textPrimary}`} data-id="element-21062" data-mp="17aix86fa9ply">
                  {format}
                </div>
                <div className={`text-sm ${dk.textMuted}`} data-id="element-21063" data-mp="1hat99npl0qzj">
                  Add a new {format} edition
                </div>
              </button>)}
        </div>
        <div className="mt-6 flex justify-end" data-id="element-21064" data-mp="1r0cuv14oiyy3">
          <button onClick={onClose} className={`px-4 py-2 rounded-lg font-medium ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`} data-id="element-21065" data-mp="1qzl0ftmtj79e">
            Cancel
          </button>
        </div>
      </div>
    </div>;
};